import { Col, Row } from 'antd';
import classnames from 'classnames';
import styles from './AppHeader.module.scss';

const AppHeader = ({ content }: any) => {
    return <h1 className={classnames(styles.title, 'hidden md:block')}>{content.Header.value}</h1>;
};

export default AppHeader;
